import React from 'react';
import { Box, Chip, Divider, Paper, Stack, Typography } from '@mui/material';
import { IDialogInboxDetail } from '../../Interfaces/IDialogInbox';
import {
  STATUS_COLOR,
  formatFieldValue,
  formatGermanDate,
  labelForField,
  labelForStatus,
} from '../i18n';

interface Props {
  detail: IDialogInboxDetail;
}

export const DialogInfoSection: React.FC<Props> = ({ detail }) => {
  const payload = detail.Data;

  // Verknüpfter Vorgang → "Vorgang erstellt" statt "Importiert".
  const effectiveStatus =
    detail.Status === 'processed' &&
    detail.LegalTransaction_idLegalTransaction != null
      ? 'created'
      : detail.Status;

  return (
    <Paper variant='outlined' sx={{ p: 2 }}>
      <Stack
        direction='row'
        spacing={1}
        alignItems='center'
        flexWrap='wrap'
        sx={{ mb: 1 }}
      >
        <Typography variant='h6'>{payload.dialogTitle}</Typography>
        <Chip
          size='small'
          label={labelForStatus(effectiveStatus)}
          color={STATUS_COLOR[effectiveStatus] ?? 'default'}
        />
      </Stack>
      <Typography variant='body2' color='text.secondary' sx={{ mb: 1 }}>
        {payload.title}
      </Typography>
      <Typography variant='caption' color='text.secondary'>
        Eingegangen am {formatGermanDate(payload.submittedAt, true)}
        {payload.transactionTypeHint
          ? ` · Vorgeschlagene Vorgangsart: ${payload.transactionTypeHint}`
          : ''}
      </Typography>

      <Divider sx={{ my: 2 }} />

      <Typography variant='subtitle2' sx={{ mb: 1 }}>
        Eingegangene Angaben
      </Typography>
      {(() => {
        // Defensiv: Einträge mit JSON-Array/-Objekt als Wert ausblenden,
        // diese stammen aus älteren ki-dia-Versionen ohne Filter.
        const visible = payload.summary.filter(e => {
          const v = (e.value ?? '').trim();
          if (!v) return false;
          if (v.startsWith('[{') || v.startsWith('{') || v.startsWith('['))
            return false;
          return true;
        });
        if (visible.length === 0) {
          return (
            <Typography variant='body2' color='text.secondary'>
              Keine zusätzlichen Felder.
            </Typography>
          );
        }
        return (
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '200px 1fr',
              rowGap: 0.5,
              columnGap: 2,
            }}
          >
            {visible.map((entry, idx) => (
              <React.Fragment key={`${entry.label}-${idx}`}>
                <Typography
                  variant='body2'
                  color='text.secondary'
                  sx={{ fontWeight: 500 }}
                >
                  {labelForField(entry.label)}
                </Typography>
                <Typography variant='body2'>
                  {formatFieldValue(entry.label, entry.value)}
                </Typography>
              </React.Fragment>
            ))}
          </Box>
        );
      })()}
    </Paper>
  );
};
